import { QueryClientHelper } from '#pplx/frontend/react-query/QueryClientHelper.js';
const SKILLS_LIST_ROOT = '/rest/skills';
// One list that spans the personal, organization, and global catalogs.
export const ALL_SKILL_SCOPES = 'all';
export const getInstalledSkillsQueryKey = () => QueryClientHelper.makeQueryKey(SKILLS_LIST_ROOT, 'installed-list');
const isInstalledSkillsListKey = (queryKey) => {
    const installedKey = getInstalledSkillsQueryKey();
    return (queryKey.length === installedKey.length &&
        queryKey.every((segment, index) => segment === installedKey[index]));
};
export const getSkillsListKey = (params) => QueryClientHelper.makeQueryKey(SKILLS_LIST_ROOT, params);
const isSkillsListParamsSegment = (segment) => typeof segment === 'object' && segment !== null && 'scope' in segment && 'limit' in segment;
const findSkillsListParams = (queryKey) => queryKey.find(isSkillsListParamsSegment);
const isSkillsListKey = (queryKey) => queryKey.includes(SKILLS_LIST_ROOT) && findSkillsListParams(queryKey) !== undefined;
export const matchSkillsListByScope = (scope) => ({
    predicate: ({ queryKey }) => isInstalledSkillsListKey(queryKey) ||
        (isSkillsListKey(queryKey) &&
            [scope, ALL_SKILL_SCOPES].includes(findSkillsListParams(queryKey)?.scope ?? '')),
});
// Viewpoints can resolve the same skill differently, so setting writes only update matching views.
export const matchSkillsListByViewScope = (viewScope) => ({
    predicate: ({ queryKey }) => (viewScope === 'individual' && isInstalledSkillsListKey(queryKey)) ||
        (isSkillsListKey(queryKey) && findSkillsListParams(queryKey)?.viewScope === viewScope),
});
export const getSkillsQueryKeyPrefix = () => QueryClientHelper.makeQueryKey('/rest/skills');
export const getSelectableSkillsKeyPrefix = () => QueryClientHelper.makeQueryKey('/rest/skills/selectable');
export const getSkillQueryKeyPrefix = (skillId) => QueryClientHelper.makeQueryKey('/rest/skills', skillId);
export const getSkillQueryKey = (skillId, viewScope = 'individual') => [...getSkillQueryKeyPrefix(skillId), viewScope];
// File contents remain valid as long as the base URL is the same
// Signed query params may change on each request to fetch signed URL
// but we should disregard as far as the file content is concerned.
// The skill details cache that contains the URL itself should follow different logic
// to avoid holding stale URLs that may be accessed.
export const getSkillArchiveIdentity = (fileUrl) => fileUrl.split('?')[0] ?? fileUrl;
export const getSkillFileContentQueryKey = (fileUrl) => QueryClientHelper.makeQueryKey('skill-file-content', getSkillArchiveIdentity(fileUrl));
export const getSkillFileEntryQueryKey = (fileUrl, path, dataUpdatedAt) => QueryClientHelper.makeQueryKey('skill-file-entry', getSkillArchiveIdentity(fileUrl), path, dataUpdatedAt);
//# sourceMappingURL=skillKeys.js.map